import { http } from "@/apps/shared/baseService/config";

class Service {
  list() {
    return http.post("/user/paymentmethod/list");
  }
}

export default new Service();
